import {LocalStorage} from "./localStorage";
import {requestVerificationToken} from "./common";

export const apiVersion = "2023-02-21";

export const api = axios.create({
    headers: {
        "RequestVerificationToken": requestVerificationToken,
        "x-api-version": apiVersion
    }
});

export const authApi = axios.create({
    headers: {
        "RequestVerificationToken": requestVerificationToken,
        "x-api-version": apiVersion
    }
});

authApi.interceptors.request.use(
    config => {
        const token = LocalStorage.getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        Promise.reject(error)
    });

authApi.interceptors.response.use((response) => {
        return response
    },
    function (error) {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {

            originalRequest._retry = true;
            return axios.post('/api/token', new URLSearchParams({ grant_type: 'client_credentials' }), { headers: {"x-api-version": apiVersion}})
                .then(res => {
                    if (res.status === 200 && res.data.access_token) {
                        LocalStorage.setToken(res.data);
                        originalRequest.headers.Authorization = `Bearer ${res.data.access_token}`;

                        return axios(originalRequest);
                    }
                });
        }
        return Promise.reject(error);
    });
